import { ExportOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Link } from '@tanstack/react-router';
import { Button, Col, Row } from 'antd';
import type { ProdutoAdicionalBody } from '@/features/produto-adicional/types/ProdutoAdicional';
import { Container } from '@/components/Container';
import { ProdutoAdicionalSelect } from '@/features/produto-adicional/components/ProdutoAdicionalSelect';

export function ProdutoTabAdicionarHeader({
    adicional,
    setAdicional,
    adicionar,
}: {
    adicional: ProdutoAdicionalBody | null;
    setAdicional: (adicional: ProdutoAdicionalBody | null) => void;
    adicionar: (adicional: ProdutoAdicionalBody) => void;
}) {
    return (
        <Container>
            <Row align='bottom' gutter={[8, 8]}>
                <Col lg={6} md={8} sm={12} xs={24}>
                    <p>Selecione o adicional</p>
                    <ProdutoAdicionalSelect
                        fetchOnMount={true}
                        onChange={(_, obj) => setAdicional(obj)}
                        value={adicional?.pra_idpk}
                    />
                </Col>

                <Col lg={6} md={8} sm={12} xl={4} xs={24}>
                    <Button
                        className='w-full'
                        disabled={!adicional}
                        icon={<PlusCircleOutlined />}
                        onClick={() => {
                            if (adicional) {
                                adicionar(adicional);
                            }
                        }}
                        type='primary'
                    >
                        Adicionar grupo
                    </Button>
                </Col>

                <Col lg={6} md={8} sm={12} xl={4} xs={24}>
                    <Link
                        search={{
                            idpk: '0',
                            mode: 'cadastrar',
                            tab1: 'produto',
                            tab2: 'adicional',
                        }}
                        target='_blank'
                        to='/a/secundario'
                    >
                        <Button className='w-full' icon={<ExportOutlined />}>
                            Cadastrar grupo
                        </Button>
                    </Link>
                </Col>
            </Row>
        </Container>
    );
}
